module.exports = __webpack_public_path__ + "img/introduce.27380692.png";